import { Event } from '@/feature/event-details-sbk/types';
import { useEventStatus } from '@/hooks/use-sbk-event-details-cache';

export const useIsMatchupLive = (event: Event) => {
    const eventStatus = useEventStatus(event.id) ?? event.status;
    return eventStatus === 'LIVE';
};
